import { useState, useEffect } from 'react';
import axios from 'axios';
import { useTrendsContext } from '../contexts/TrendsContext.js';
import { API_URLS } from '../api/config.js';
import { applyBrandNameCorrections } from '../utils/brandNameCorrections.js';

export const useTrendAnalysis = (categoryId, mainIds, comparisonIds, shouldFetch = false, retryTrigger = 0) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { analysisCache, updateAnalysisCache } = useTrendsContext();

  useEffect(() => {
    const fetchData = async () => {
      if (!categoryId || !shouldFetch) return;
      if (analysisCache) return; // 캐시된 데이터가 있으면 요청하지 않음

      const startTime = Date.now();

      try {
        setLoading(true);
        setError(null);

        const requestBody = {
          category: categoryId,
          ...(mainIds && Object.keys(mainIds).length > 0 && { criteria: mainIds }),
          ...(comparisonIds && { secondSetCriteria: comparisonIds })
        };

        const response = await axios({
          method: 'post',
          url: `${API_URLS.API}/trends/filters`,
          headers: { 'Content-Type': 'application/json' },
          data: requestBody,
          timeout: 60000 // 60 seconds timeout
        });

        console.log("filters 요청");
        updateAnalysisCache(applyBrandNameCorrections(response.data));
      } catch (err) {
        const elapsedTime = Date.now() - startTime;
        const errorMessage = err.response?.data?.message || err.message;
        const statusCode = err.response?.status;

        // Create enhanced error object with timing and status info
        const enhancedError = {
          message: errorMessage,
          elapsedTime: elapsedTime,
          statusCode: statusCode,
          isTimeout: elapsedTime >= 60000, // 60 seconds
          isNoData: statusCode === 422 // Unprocessable Entity = no matching items
        };

        setError(enhancedError);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [categoryId, mainIds, comparisonIds, shouldFetch, analysisCache, updateAnalysisCache, retryTrigger]);

  return { data: analysisCache, loading, error };
};